import { render, staticRenderFns } from "./ReviewFieldsPayment.vue?vue&type=template&id=18770e24"
import script from "./ReviewFieldsPayment.vue?vue&type=script&lang=ts"
export * from "./ReviewFieldsPayment.vue?vue&type=script&lang=ts"
import style0 from "./ReviewFieldsPayment.vue?vue&type=style&index=0&id=18770e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports